export default __webpack_public_path__ + "static/media/logo-ae-Firstcry.b1bb69df.svg";